// Sprint 4A.7 — Mapping label italiani per i campi mostrati nell'audit log raggruppato.
// Le entry audit nuove usano chiavi campo tecniche (es. "prezzo_acquisto").
// Questa mappa le traduce in label italiane leggibili.

export const auditFieldLabels = {
  // ---------- Veicolo: anagrafica ----------
  "marca": "Marca",
  "modello": "Modello",
  "versione": "Versione",
  "allestimento": "Allestimento",
  "targa": "Targa",
  "telaio": "Telaio",
  "prima_immatricolazione": "Prima immatricolazione",
  "seconda_immatricolazione": "Seconda immatricolazione",
  "n_proprietari": "N° proprietari",
  "provenienza": "Provenienza",
  "nazione_provenienza": "Nazione di provenienza",
  "km": "Chilometri",
  "kw": "kW",
  "cv": "CV",
  "cilindrata": "Cilindrata (cc)",
  "carburante": "Carburante",
  "cambio": "Cambio",
  "trazione": "Trazione",
  "colore": "Colore",
  "secondo_colore": "Secondo colore",
  "tipo_colore": "Tipo colore",
  "n_marce": "N° marce",
  "classe_euro": "Classe Euro",
  "emissioni_co2": "Emissioni CO₂",
  "consumo_urbano": "Consumo urbano",
  "consumo_extraurbano": "Consumo extraurbano",
  "consumo_misto": "Consumo misto",
  "n_porte": "N° porte",
  "n_posti": "N° posti",
  "peso": "Peso",
  "listino": "Listino",

  // ---------- Veicolo: stato / sede / azienda ----------
  "stato": "Stato",
  "status": "Disponibilità",
  "company_id": "Azienda",
  "site_id": "Sede",
  "data_carico": "Data carico",
  "tipo_carico": "Tipo carico",
  "aliquota_iva_acquisto": "Aliquota IVA acquisto",
  "supplier_id": "Fornitore",
  "cointestatario_id": "Cointestatario",
  "data_atto": "Data atto",
  "numero_atto": "N° atto",
  "inizio_mandato": "Inizio mandato",
  "fine_mandato": "Fine mandato",
  "deposito": "Deposito",
  "deposito.tipo": "Deposito - Tipo",
  "deposito.sede_id": "Deposito - Sede",
  "deposito.anagrafica_id": "Deposito - Soggetto",
  "deposito.note": "Deposito - Note",

  // ---------- Veicolo: importi ----------
  "importi": "Importi",
  "importi.prezzo_acquisto": "Prezzo acquisto",
  "importi.miniatto": "Miniatto",
  "importi.approntamento": "Trasporto",
  "importi.margine_minimo": "Margine minimo",
  "importi.prezzo_web": "Prezzo web",
  "importi.spese_generiche": "Spese generiche",
  "importi.spese_ripristino": "Spese ripristino",
  "importi.listino": "Listino casa madre",
  "importi.listino_casa_madre": "Listino casa madre",
  "importi.sconto_perc_prezzo_web": "Sconto % prezzo web da listino",
  "importi.sconto_eur_prezzo_web_da_listino": "Sconto € prezzo web da listino",

  // ---------- Scadenze ----------
  "scadenze": "Scadenze",
  "scadenze.bollo": "Bollo",
  "scadenze.revisione": "Revisione",
  "scadenze.assicurazione": "Assicurazione",
  "scadenze.garanzia": "Garanzia",

  // ---------- Foto ----------
  "foto": "Foto",

  // ---------- Anagrafica: persona ----------
  "tipo_persona": "Tipo persona",
  "nome": "Nome",
  "cognome": "Cognome",
  "ragione_sociale": "Ragione sociale",
  "codice_fiscale": "Codice fiscale",
  "partita_iva": "Partita IVA",
  "data_nascita": "Data di nascita",
  "luogo_nascita": "Luogo di nascita",
  "provincia_nascita": "Provincia di nascita",
  "nazione_nascita": "Nazione di nascita",
  "telefono": "Telefono",
  "cellulare": "Cellulare",
  "email": "Email",
  "pec": "PEC",
  "sdi": "Codice SDI",
  "iban": "IBAN",

  // ---------- Anagrafica: indirizzo ----------
  "indirizzo": "Indirizzo",
  "indirizzo.via": "Indirizzo - Via",
  "indirizzo.civico": "Indirizzo - Civico",
  "indirizzo.cap": "Indirizzo - CAP",
  "indirizzo.comune": "Indirizzo - Comune",
  "indirizzo.provincia": "Indirizzo - Provincia",
  "indirizzo.nazione": "Indirizzo - Nazione",

  // ---------- Anagrafica: documento identità ----------
  "documento": "Documento",
  "documento.tipo": "Documento - Tipo",
  "documento.numero": "Documento - Numero",
  "documento.rilasciato_da": "Documento - Rilasciato da",
  "documento.data_rilascio": "Documento - Data rilascio",
  "documento.data_scadenza": "Documento - Data scadenza",

  // ---------- Anagrafica: categorie / ruoli ----------
  "categorie": "Categorie",
  "categorie.base": "Categorie - Base",
  "categorie.fornitore": "Categorie - Fornitore",
  "categorie.altro": "Categorie - Altro",

  // ---------- Vendita ----------
  "tipo": "Tipo",
  "cliente_id": "Cliente",
  "cointestatario_vendita_id": "Cointestatario",
  "venditore_id": "Venditore",
  "data_impegno": "Data impegno",
  "data_contratto": "Data contratto",
  "data_consegna_prevista": "Data consegna prevista",
  "data_consegna_effettiva": "Data consegna effettiva",
  "data_scadenza": "Data scadenza",
  // Sprint 4B: Preventivi
  "giorni_validita_preventivo": "Giorni validità preventivo",
  "data_scadenza_preventivo": "Data scadenza preventivo",
  "preventivo_origine_id": "Preventivo di origine",
  "pratica_generata_id": "Pratica generata",
  "prezzo_vendita_veicolo": "Prezzo vendita veicolo",
  "prezzo_vendita_approntamento": "Prezzo vendita approntamento",
  "nascondi_importi_acquisto": "Nascondi importi acquisto",
  "modalita_iva": "Modalità IVA",
  "iva_aliquota": "Aliquota IVA",
  "note_pratica": "Note pratica",
  "note_interne": "Note interne",
  "forced_sotto_margine": "Forzata sotto margine",
  "pagamenti": "Pagamenti",
  "righe_servizi": "Righe servizi",
  "righe_accessori": "Righe accessori",
  "righe_sconti": "Righe sconti",
  "righe_garanzie": "Righe garanzie",
  "righe_garanzie.provider_id": "Provider garanzia",
  "righe_garanzie.descrizione": "Descrizione garanzia",
  "righe_garanzie.durata_mesi": "Durata garanzia (mesi)",
  "righe_garanzie.prezzo_acquisto": "Acquisto garanzia",
  "righe_garanzie.prezzo_vendita": "Vendita garanzia",
  "righe_garanzie.provvigione_attiva": "Provvigione attiva",
  "righe_garanzie.provvigione_tipo": "Tipo provvigione",
  "righe_garanzie.provvigione_percentuale": "Provvigione %",
  "righe_garanzie.provvigione_importo_fisso": "Provvigione fissa",
  "righe_garanzie.note": "Note garanzia",
  "finanziamento": "Finanziamento",
  "finanziamento.intestatario_id": "Intestatario finanziamento",
  "finanziamento.garante_id": "Garante finanziamento",
  "finanziamento.finanziaria_id": "Finanziaria",
  "finanziamento.prodotto_descrizione": "Prodotto/descrizione",
  "finanziamento.numero_pratica": "N° pratica",
  "finanziamento.importo_finanziato": "Importo finanziato",
  "finanziamento.spese_istruttoria": "Spese istruttoria",
  "finanziamento.importo_assicurazione": "Importo assicurazione",
  "finanziamento.compagnia_assicurativa": "Compagnia assicurativa",
  "finanziamento.durata_copertura_mesi": "Durata copertura (mesi)",
  "finanziamento.descrizione_assicurazione": "Descrizione assicurazione",
  "finanziamento.status_finanziamento": "Stato finanziamento",
  "finanziamento.rate_periodo_1.numero_rate": "1° periodo · N° rate",
  "finanziamento.rate_periodo_1.importo_rata": "1° periodo · Importo rata",
  "finanziamento.rate_periodo_1.tan_percent": "1° periodo · TAN %",
  "finanziamento.rate_periodo_1.taeg_percent": "1° periodo · TAEG %",
  "finanziamento.rate_periodo_1.maxirata": "1° periodo · Maxirata",
  "finanziamento.rate_periodo_2.numero_rate": "2° periodo · N° rate",
  "finanziamento.rate_periodo_2.importo_rata": "2° periodo · Importo rata",
  "finanziamento.rate_periodo_2.tan_percent": "2° periodo · TAN %",
  "finanziamento.rate_periodo_2.taeg_percent": "2° periodo · TAEG %",
  "finanziamento.provvigioni_tipo": "Tipo provvigioni",
  "finanziamento.provvigione_lorda_totale": "Provvigione lorda totale",
  "finanziamento.proventi_finanziamento": "Proventi finanziamento",
  "finanziamento.proventi_spese_pratica": "Proventi spese pratica",
  "finanziamento.proventi_assicurazione_tipo": "Tipo proventi assicurazione",
  "finanziamento.proventi_assicurazione_percentuale": "Proventi assicurazione %",
  "finanziamento.proventi_assicurazione_fisso": "Proventi assicurazione fisso",
  "categoria_veicolo": "Categoria veicolo",
  "permuta": "Permuta",
};

export function getFieldLabel(key) {
  if (!key) return "";
  return auditFieldLabels[key] || key;
}

/**
 * Formatta un valore per la visualizzazione nell'audit.
 * - null/undefined/"" → "—"
 * - bool → Sì/No
 * - date ISO → DD/MM/YYYY
 * - numeri per campi monetari → formato EUR
 * - array/object → "(modificato)" con count se disponibile
 */
export function formatAuditValue(val, fieldKey) {
  if (val === null || val === undefined || val === "") return "—";
  if (typeof val === "boolean") return val ? "Sì" : "No";
  if (Array.isArray(val)) {
    return val.length === 0 ? "— (vuoto)" : `(${val.length} element${val.length === 1 ? "o" : "i"})`;
  }
  if (typeof val === "object") {
    return "(modificato)";
  }
  // Numeri su campi monetari
  const moneyKeys = [
    "prezzo_acquisto", "miniatto", "approntamento", "margine_minimo", "prezzo_web",
    "listino", "prezzo_vendita_veicolo", "prezzo_vendita_approntamento",
  ];
  const fieldTail = (fieldKey || "").split(".").slice(-1)[0];
  if (typeof val === "number" && moneyKeys.includes(fieldTail)) {
    try {
      return new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR",
        minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(val);
    } catch { return String(val); }
  }
  // Date ISO (YYYY-MM-DD o YYYY-MM-DDT...)
  if (typeof val === "string" && /^\d{4}-\d{2}-\d{2}(T|$)/.test(val)) {
    try {
      const d = new Date(val);
      if (!isNaN(d.getTime())) {
        const pad = (n) => String(n).padStart(2, "0");
        return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
      }
    } catch { /* fallthrough */ }
  }
  return String(val);
}
